export { default as EnBanner } from './EnBanner.vue';
export { default } from './EnBanner.vue';
